import { styled, Typography, TypographyProps } from "@mui/material";

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  marginLeft: theme.spacing(1),
  fontSize: "2rem",
  fontWeight: "bold",
}));

const PageTitle: React.FC<TypographyProps> = ({ children, variant, ...props }) => {
  return (
    <StyledTypography variant={variant ?? "h1"} {...props}>
      {children}
    </StyledTypography>
  );
};

export default PageTitle;
